import { filtersHelper } from '@/utils';
import { meetingRoomModel } from '@/models/app/meetingRoom.model';

export const meetingRoomBookingModel = (data) => ({
    uuid: data.uuid,
    agenda: data.agenda,
    description: data.description,
    startAt: data.start,
    endAt: data.end,
    date: filtersHelper.getDateFormat(data.start),
    start: filtersHelper.getTimeFormat(data.start),
    end: filtersHelper.getTimeFormat(data.end),
    isInterview: data.is_interview,
    type: data.type,
    isActive: data.is_active,
    createdAt: filtersHelper.getDateFormat(data.created_at),
    createdBy: data.created_by,
    updatedAt: filtersHelper.getDateFormat(data.updated_at),
    updatedBy: data.updated_by,
    deletedAt: filtersHelper.getDateFormat(data.deleted_at),
    deletedBy: data.deleted_by,
    createdByUser: data.created_by_user ? {
        uuid: data.created_by_user.uuid,
        firstName: data.created_by_user.first_name,
        lastName: data.created_by_user.lastName,
        birthDate: data.created_by_user.birth_date,
        email: data.created_by_user.email,
        emailVerifiedAt: filtersHelper.getDateFormat(data.created_by_user.email_verified_at),
        phoneCode: data.created_by_user.phone_code,
        phone: data.created_by_user.phone,
        phoneIso: data.created_by_user.phone_iso,
        image: data.created_by_user.image,
        isActive: data.created_by_user.is_active,
        isOrientation: data.created_by_user.is_orientation,
        userType: data.created_by_user.user_type,
        totalModulesCompleted: data.created_by_user.total_modules_completed,
        createdAt: filtersHelper.getDateFormat(data.created_by_user.created_at),
        createdBy: data.created_by_user.created_by,
        updatedAt: filtersHelper.getDateFormat(data.created_by_user.updated_at),
        updatedBy: data.created_by_user.updated_by,
    } : null,
    meetingRoom: data.meeting_room ? meetingRoomModel(data.meeting_room) : null,
});